export { useAudioLevel } from "./useAudioLevel";
export {
  useMicrophonePermission,
  type MicrophonePermissionState,
} from "./useMicrophonePermission";
export { useMediaDevices, type MediaDeviceInfo } from "./useMediaDevices";
export {
  useConversation,
  type UseConversationOptions,
} from "./useConversation";

// Legacy export for backward compatibility
export { useConversation as useVoiceChatSession } from "./useConversation";
export type { UseConversationOptions as UseVoiceChatSessionOptions } from "./useConversation";
